import { makeStyles } from '@material-ui/core'

export const sidebarWidth = 240

export const useSidebarStyles = makeStyles(() => ({
  drawer: {
    width: sidebarWidth,
  },
  drawerPaper: {
    width: sidebarWidth,
  },
}))
